import { nullifyUndefinedProperties } from 'tradera-utils/object';

export default initData => {
    const {
        cleanedMemberAlias,
        facebookId,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberCountryCodeIso2,
        memberEmail,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        memberBirthdate,
        paymentSettings = {}
    } = initData;
    return nullifyUndefinedProperties({
        cleanedMemberAlias,
        facebookId,
        geolocation: null,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberCountryCodeIso2,
        memberEmail,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        memberBirthdate,
        paymentSettings
    });
};
